export const CHANNELS_FETCH = "CHANNELS_FETCH";
export const CHANNELS_PATCH = "CHANNELS_PATCH";
export const CHANNELS_DATES = "CHANNELS_DATES";
export const GRID_CHANNELS_FETCH = "GRID_CHANNELS_FETCH";
